import { InteractiveContainer } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import React from "react";
import { ReactComponent as WhatsappIcon } from "./assets/whatsapp.svg";
import { ReactComponent as CheckIcon } from "./assets/check.svg";

export const TemplateTile: React.FC<{
  name: string;
  body: string;
  isSelected: boolean;
  onSelect: () => void;
}> = ({ isSelected, name, body, onSelect }) => (
  <InteractiveContainer
    className={cx(
      "flex flex-col rounded-xl p-3 transition-colors",
      isSelected && "bg-[#EFF8FF]"
    )}
    onClick={onSelect}
  >
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2 overflow-hidden">
        <WhatsappIcon className="shrink-0" />
        <span className="text-dark font-secondary truncate font-medium leading-4">
          {name}
        </span>
      </div>
      {isSelected && <CheckIcon />}
    </div>
    <span className="font-secondary jugl__break-word text-sm leading-[140%] text-[#828282]">
      {body}
    </span>
  </InteractiveContainer>
);
